import axios, { AxiosError } from "axios";

// export const API_BASE = "http://localhost:5011"; // Change as needed
export const API_BASE = "https://stg-api.etestai.com";

function getAuthHeaders() {
	//   const token = Cookies.get("token"); // Replace 'token' if your cookie name is different
	return {};
}

axios.interceptors.response.use(
	(response) => response?.data ?? undefined,
	(error: AxiosError) => {
		const { message, code, config, request, response } = error;
		if (error?.response?.status === 401 || error?.response?.status === 403) {
			const url = new URL(error.config?.url || "");
			if("/auth/verify-otp" === url.pathname) {
				throw new AxiosError(message, code, config, request, response);
			}
			if (!["/user/profile", "/auth/verify-otp"].find((x) => x === url.pathname)) {
				window.location.href = "/login";
			}
		} else if (error?.response?.status === 402) {
			if (!["/pricing"].find((x) => x === window.location.pathname)) {
				window.location.href = "/pricing";
			}
		} else {
			throw new AxiosError(message, code, config, request, response);
		}
	}
);

export async function get<T>(url: string, params?: object): Promise<T> {
	return await axios.get(`${API_BASE}${url}`, {
		params,
		headers: { ...getAuthHeaders() },
		withCredentials: true,
	});
}

export async function post<T>(url: string, data?: object): Promise<T> {
	return await axios.post(`${API_BASE}${url}`, data, {
		headers: { ...getAuthHeaders() },
		withCredentials: true,
	});
}

export async function patch<T>(url: string, data?: object): Promise<T> {
	return await axios.patch(`${API_BASE}${url}`, data, {
		headers: { ...getAuthHeaders() },
		withCredentials: true,
	});
}

export async function del<T>(url: string, data?: object): Promise<T> {
	return await axios.delete(`${API_BASE}${url}`, {
		data,
		headers: { ...getAuthHeaders() },
		withCredentials: true,
	});
}
